import { LangHelper, SessionHelper } from "@jnpmedi/helper-session";
import axios from "axios";

export const sessionHelper = new SessionHelper({ stage: process.env.REACT_APP_STAGE! });
export const langHelper = new LangHelper({ stage: process.env.REACT_APP_STAGE! });
export const setDefaultAuthorization = (token: string): void => {
  axios.defaults.headers.common.Authorization = token;
};
